import { jsxs, jsx } from 'react/jsx-runtime';
import { useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".modal__overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--phx-modalBackgroundColor, #000);\n  opacity: var(--phx-modalOpacity, 0.8);\n}\n.modal__wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  outline: 0;\n}\n.modal__container {\n  z-index: 100;\n  background: var(--phx-modalBackgroundContainer, #fff);\n  position: relative;\n  margin: auto;\n  top: 50%;\n  transform: translateY(-50%);\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  overflow-y: auto;\n  max-height: var(--phx-modalMaxHeight, calc(100% - 64px));\n  border-radius: var(--phx-modalBorderRadius, 8px);\n}\n.modal__content {\n  padding: 40px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm1vZGFsLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxlQUFlO0VBQ2YsTUFBTTtFQUNOLE9BQU87RUFDUCxhQUFhO0VBQ2IsWUFBWTtFQUNaLGFBQWE7RUFDYix1REFBdUQ7RUFDdkQscUNBQXFDO0FBQ3ZDO0FBQ0E7RUFDRSxlQUFlO0VBQ2YsTUFBTTtFQUNOLE9BQU87RUFDUCxhQUFhO0VBQ2IsV0FBVztFQUNYLFlBQVk7RUFDWixnQkFBZ0I7RUFDaEIsVUFBVTtBQUNaO0FBQ0E7RUFDRSxZQUFZO0VBQ1oscURBQXFEO0VBQ3JELGtCQUFrQjtFQUNsQixZQUFZO0VBQ1osUUFBUTtFQUNSLDJCQUEyQjtFQUMzQiwwQkFBa0I7RUFBbEIsdUJBQWtCO0VBQWxCLGtCQUFrQjtFQUNsQixnQkFBZ0I7RUFDaEIsd0RBQXdEO0VBQ3hELGdEQUFnRDtBQUNsRDtBQUNBO0VBQ0UsYUFBYTtBQUNmIiwiZmlsZSI6Im1vZGFsLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubW9kYWxfX292ZXJsYXkge1xuICBwb3NpdGlvbjogZml4ZWQ7XG4gIHRvcDogMDtcbiAgbGVmdDogMDtcbiAgei1pbmRleDogMTA0MDtcbiAgd2lkdGg6IDEwMHZ3O1xuICBoZWlnaHQ6IDEwMHZoO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1waHgtbW9kYWxCYWNrZ3JvdW5kQ29sb3IsICMwMDApO1xuICBvcGFjaXR5OiB2YXIoLS1waHgtbW9kYWxPcGFjaXR5LCAwLjgpO1xufVxuLm1vZGFsX193cmFwcGVyIHtcbiAgcG9zaXRpb246IGZpeGVkO1xuICB0b3A6IDA7XG4gIGxlZnQ6IDA7XG4gIHotaW5kZXg6IDEwNTA7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIG91dGxpbmU6IDA7XG59XG4ubW9kYWxfX2NvbnRhaW5lciB7XG4gIHotaW5kZXg6IDEwMDtcbiAgYmFja2dyb3VuZDogdmFyKC0tcGh4LW1vZGFsQmFja2dyb3VuZENvbnRhaW5lciwgI2ZmZik7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgbWFyZ2luOiBhdXRvO1xuICB0b3A6IDUwJTtcbiAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKC01MCUpO1xuICB3aWR0aDogZml0LWNvbnRlbnQ7XG4gIG92ZXJmbG93LXk6IGF1dG87XG4gIG1heC1oZWlnaHQ6IHZhcigtLXBoeC1tb2RhbE1heEhlaWdodCwgY2FsYygxMDAlIC0gNjRweCkpO1xuICBib3JkZXItcmFkaXVzOiB2YXIoLS1waHgtbW9kYWxCb3JkZXJSYWRpdXMsIDhweCk7XG59XG4ubW9kYWxfX2NvbnRlbnQge1xuICBwYWRkaW5nOiA0MHB4O1xufSJdfQ== */";
styleInject(css_248z);

var Modal = function Modal(_ref) {
  var isShowing = _ref.isShowing,
      children = _ref.children,
      close = _ref.close,
      disableOnClickClose = _ref.disableOnClickClose,
      className = _ref.className;
  var handleEscape = useCallback(function (event) {
    if (event.keyCode === 27 && close) close();
  }, [close]);
  useEffect(function () {
    if (isShowing && close) {
      document.addEventListener('keydown', handleEscape, false);
    }

    return function () {
      document.removeEventListener('keydown', handleEscape, false);
    };
  }, [close, isShowing, handleEscape]);
  return isShowing ? ReactDOM.createPortal(jsxs("div", Object.assign({
    className: className
  }, {
    children: [jsx("div", {
      className: "modal__overlay"
    }), jsx("div", Object.assign({
      className: "modal__wrapper",
      "aria-modal": true,
      "aria-hidden": true,
      tabIndex: -1,
      role: "dialog",
      onClick: !disableOnClickClose && close ? close : undefined,
      "data-testid": "modal-wrapper"
    }, {
      children: jsx("div", Object.assign({
        className: "modal__container",
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        "aria-hidden": true
      }, {
        children: children
      }))
    }))]
  })), document.body) : null;
};

export { Modal };